export default __webpack_public_path__ + "static/media/bank_soal.1ecd4226.svg";